import { type StateCreator } from 'zustand';

export type WorkspaceSidebarResizingSlice = {
  isResizing: boolean;
  setIsResizing: (isResizing: boolean) => void;
};

export type CreateWorkspaceSidebarResizingSlice = () => StateCreator<
  WorkspaceSidebarResizingSlice,
  [],
  [],
  WorkspaceSidebarResizingSlice
>;

export const createWorkspaceSidebarResizingSlice: CreateWorkspaceSidebarResizingSlice = () => (set) => ({
  isResizing: false,
  setIsResizing: (isResizing: boolean) => set({ isResizing }),
});
